import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

// @mui material components
import Card from '@mui/material/Card'
import Badge from '@mui/material/Badge'
import Modal from '@mui/material/Modal'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Footer from 'examples/Footer'
import DataTable from 'examples/Tables/DataTable'
import MDButton from 'components/MDButton'
import MDAlert from 'components/MDAlert'
import { Tooltip, IconButton } from '@mui/material'

import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'

import CrudService from 'services/cruds-service'
import moment from 'moment/moment'

function QueueList() {
    let { state } = useLocation()
    const [data, setData] = useState([])
    const [tableData, setTableData] = useState([])
    const [notification, setNotification] = useState({
        value: false,
        text: '',
    })

    const navigate = useNavigate()

    useEffect(() => {
        ; (async () => {
            const response = await CrudService.fetchQueueList()
            setData(response.data)
        })()
        document.title = `Rivio | Queue List`
    }, [])

    useEffect(() => {
        if (!state) return
        setNotification({
            value: state.value,
            text: state.text,
        })
    }, [state])

    useEffect(() => {
        setTableData(getRows(data))
    }, [data])

    useEffect(() => {
        if (notification.value === true) {
            let timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: '',
                })
            }, 5000)
        }
    }, [notification])


    const clickDeleteHandler = async (e, external_id, id) => {
        try {
            if (!confirm('Are you sure you want to delete this queue?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                let resp = await CrudService.removeDeviceSetting(external_id, id)
                // the delete does not send a response
                // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
                const response = await CrudService.fetchQueueList()
                setData(response.data)
                setNotification({
                    value: true,
                    text: 'The queue has been successfully deleted',
                })
            }
        } catch (err) {
            // it sends error is the item is associated with an item
            console.error(err)
            setNotification({
                value: true,
                text: err.error,
            })
            return null
        }
    }

    const getRows = (info) => {
        let updatedInfo = info.map((row) => {
            const entity = row.Device?.EntityAddressItem?.Entity
            const entityName = entity?.name;
            const firstName = entity?.first_name;
            const lasttName = entity?.last_name;
            return {
                ...row,
                type: 'queue',
                device_name: row.Device.name,
                address_item_name: row.Device?.EntityAddressItem?.name,
                item_name: row.Device?.EntityAddressItem?.Item?.name,
                entity_name: entityName ? entityName : firstName + ' ' + lasttName,
                external_device_id: row.Device?.ExternalDeviceMapping?.external_device_id,
                status: row.StatusType.status_name,
                downlink_value: row.downlink_value ? JSON.stringify(row.downlink_value) : ''
            }
        })
        return updatedInfo
    }

    const dataTableData = {
        columns: [
            { Header: 'Device ID', accessor: 'device_id', width: '5%' },
            { Header: 'External Device ID', accessor: 'external_device_id', width: '5%' },
            {
                Header: 'Status', accessor: 'status', width: '10%', Cell: (info) => {
                    return (
                        <Badge
                            color={
                                info.value === 'Pending' ? 'info' : 'success'
                            }
                            variant={'standard'}
                            badgeContent={info.value}
                            style={{ marginLeft: "20px" }}
                        ></Badge>
                    )
                }
            },
            { Header: 'Device Name', accessor: 'device_name', width: '15%' },
            { Header: 'Address Item Name', accessor: 'address_item_name', width: '15%' },
            { Header: 'Item Name', accessor: 'item_name', width: '15%' },
            { Header: 'Entity Name', accessor: 'entity_name', width: '15%' },
            { Header: 'Alarm height', accessor: 'alarm_height', width: '10%' },
            { Header: 'Upload time', accessor: 'upload_time', width: '10%' },
            { Header: 'Downlink value', accessor: 'downlink_value', width: '10%' },
            { Header: 'Created', accessor: 'created_at', width: '10%', Cell: (info) => moment(info.value).format('MM/DD/yyyy h:mm:ss A') },
            { Header: 'Updated', accessor: 'updated_at', width: '10%', Cell: (info) => moment(info.value).format('MM/DD/yyyy h:mm:ss A') },
            {
                Header: 'actions',
                disableSortBy: true,
                accessor: '',
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="Delete Item">
                                <IconButton
                                    onClick={(e) =>
                                        clickDeleteHandler(e, info.row.values.external_device_id, info.row.values.device_id)
                                    }
                                >
                                    <MDTypography>
                                        <DeleteIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    )
                },
            },
        ],

        rows: tableData,
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {notification.value && (
                <MDAlert color="info" my="20px">
                    <MDTypography variant="body2" color="white">
                        {notification.text || ''}
                    </MDTypography>
                </MDAlert>
            )}
            <MDBox pt={1}>
                <MDBox>
                    <Card>
                        <MDBox
                            p={3}
                            lineHeight={1}
                            display="flex"
                            justifyContent="space-between"
                        >
                            <MDTypography variant="h5" fontWeight="medium">
                                Queue List
                            </MDTypography>
                        </MDBox>
                        <DataTable table={dataTableData} />
                    </Card>
                </MDBox>
            </MDBox>
            <Footer />
        </DashboardLayout>
    )
}

export default QueueList
